import React from 'react'
import { Collapse } from 'antd'
import cx from 'classnames'

const CollapseDetails = ({
  headerComponent,
  contentComponent,
  className,
  itemKey,
  defaultActiveKey,
  backgroundColor = 'var(--white)'
}) => {
  return (
    <Collapse
      key={itemKey}
      expandIconPosition='end'
      className={cx('collapse-details-container', className)}
      bordered={false}
      defaultActiveKey={defaultActiveKey}
      expandIcon={({ isActive }) => (
        <span className={`icon-arrow-bold-${isActive ? 'up' : 'down'}`} />
      )}
      style={{ backgroundColor: backgroundColor }}
      items={[
        {
          key: `${itemKey}-panel`,
          label: headerComponent,
          children: contentComponent
        }
      ]}
    />
  )
}

export default CollapseDetails
